<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div v-if="typeNr == 0" class="form">
                        <div class="form-group row">
                            <label for="colFormLabel1" class="col-sm-2 col-form-label">lidwoord</label>
                            <div class="col-sm-10">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="colFormLabel1"
                                    placeholder="col-form-label"
                                    v-model="l" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="colFormLabel2" class="col-sm-2 col-form-label">woord</label>
                            <div class="col-sm-10">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="colFormLabel2"
                                    placeholder="col-form-label"
                                    v-model="w" />
                            </div>
                        </div>
                    </div>

                    <div v-if="typeNr == 1" class="form">
                        <div class="form-group row">
                            <div class="col">
                                <textarea
                                    rows="8"
                                    type="text"
                                    class="form-control"
                                    id="colFormLabel1"
                                    placeholder="col-form-label"
                                    v-model="z" />
                            </div>
                        </div>
                    </div>

                    <button class="btn btn-outline-primary" @click="$emit('close', $event, l, w, z)">OK</button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        typeNr: Number,
        item: Object,
    },

    data() {
        return {
            l: '',
            w: '',
            z: '',
        };
    },

    created: function () {
        if (this.typeNr == 0) {
            this.l = this.item.lidwoord_de;
            this.w = this.item.woord_de;
        }
        if (this.typeNr == 1) {
            this.z = this.item.zin_de;
        }
    },
};
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 600px;
    margin: 0px auto;
    padding: 30px 30px 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
    margin-top: 0;
    color: #42b983;
}

.modal-body {
    margin: 20px 0;
}

.modal-default-button {
    float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>
